import React, { useRef, useState } from "react";
// import { api_private_get, formatStringAmountUSD } from "script";
// import { Link } from 'react-router-dom';
// import UnverifiedUserMessage from "./UnverifiedUserMessage";

function ChatMessage({ name, time, message, profileImg, attachmentImg }) {
  return (
    <div className="d-flex align-items-start gap-4 mb-4">
      <div className="cmns_msgarea__head-thumb">
        <img className="rounded-5" src={profileImg} alt="Icon" />
      </div>
      <div className="cmns_msgarea__head-conent">
        <div className="d-flex align-items-center gap-2">
          <h6>{name}</h6>
          <span className="n3-color seven">{time}</span>
        </div>
        <p>{message}</p>
        {attachmentImg && (
          <img className="mt-2" src={attachmentImg} alt="Attachment" />
        )}
      </div>
    </div>
  );
}

function HeaderChat({ showChat, setShowChat }) {
  // const [showChat, setShowChat] = useState(true);
  const [message, setMessage] = useState("");
  const [chatMessages, setChatMessages] = useState([
    {
      name: "IntPulse.io",
      time: new Date().toLocaleString(), //"Jul 24 21:28",
      message:
        "Welcome to IntPulse™! This chat is not connected to any real-time messaging service.\nFeel free to explore and interact with the chat interface.",
      profileImg: "/assets/images/miles.png",
    },
  ]);

  const chatAreaRef = useRef(null);

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (message.trim() === "") return;

    console.log("Message sent:", message);

    // Add message to chat area locally
    setChatMessages((prevMessages) => [
      ...prevMessages,
      {
        name: "You",
        time: new Date().toLocaleString(),
        message: message,
        profileImg: "/assets/images/miles.png",
      },
    ]);
    setShowChat(true); // Ensure chat is visible after sending a message

    setTimeout(() => {
      if (chatAreaRef.current) {
        chatAreaRef.current.scrollTop = chatAreaRef.current.scrollHeight;
      }
    }, 100); // Scroll to the bottom after a short delay

    setMessage(""); // Clear the input field
  };

  return (
    <div
      className={`cmns_msgarea msg_area common_area2 p2-bg rounded-2 ${showChat ? "show" : ""}`}
    >
      <div className="cmns_msgarea__head d-flex align-items-center justify-content-between gap-5 n11-bg px-6 py-2">
        <div
          className="d-flex align-items-center gap-2"
          onClick={() => setShowChat(!showChat)}
        >
          <button type="button">
            <i className="ti ti-menu-2 fs-four n5-color"></i>
          </button>
          <h5 className="fs-five">Chat</h5>
        </div>
        <div className="common_toggles3" onClick={() => setShowChat(false)}>
          <i className="ti ti-x fs-four cpoint n5-color"></i>
        </div>
      </div>
      <div className="cmns_msgarea__body p-5 p-md-6" ref={chatAreaRef}>
        {chatMessages.map((msg, idx) => (
          <ChatMessage
            key={idx}
            name={msg.name}
            time={msg.time}
            message={msg.message}
            profileImg={msg.profileImg}
            attachmentImg={msg.attachmentImg}
          />
        ))}
      </div>
      <div className="cmns_msgarea__footer py-4 py-md-5 px-5 px-md-6 position-absolute bottom-0 n11-bg w-100">
        <form
          onSubmit={handleSendMessage}
          className="d-flex align-items-center justify-content-end flex-wrap flex-sm-nowrap gap-2 gap-sm-5 w-100"
        >
          <div className="cmns_msgarea__footer-fileup d-flex align-items-center py-1 pe-3 gap-sm-1">
            <input
              type="text"
              placeholder="Send message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <label htmlFor="img">
              <i className="ti ti-photo-plus fs-four cpoint"></i>
            </label>
            <input className="d-none" type="file" id="img" />
            <span>
              <i className="ti ti-at fs-four cpoint"></i>
            </span>
            <label htmlFor="pdf">
              <i className="ti ti-file-type-pdf fs-four cpoint"></i>
            </label>
            <input className="d-none" type="file" id="pdf" />
            <span>
              <i className="ti ti-mood-happy fs-four cpoint"></i>
            </span>
          </div>
          <button className="py-3 px-5 g1-bg rounded-8">
            <i className="ti ti-send fs-four"></i>
          </button>
        </form>
      </div>
    </div>
  );
}

export default HeaderChat;
